import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getTotalUsers,
  getTotalPublicProjects,
  getTotalPublicQuotations,
  getTotalPrivateQuotations,
  getTotalNewUsers,
  getTotalNewPublicProjects,
  getTotalNewPrivateProjects,
  getTotalNewPublicQuotations,
  getTotalNewPrivateQuotations,
} from "../../store/actions";
import styles from "./QuePasaEnEdify.module.scss";
import { useHistory } from "react-router-dom";
import { ReactComponent as PlusIcon } from "../../assets/svg/plus-icon.svg";
import { ReactComponent as PublicProjectIcon } from "../../assets/svg/ObraPublica.svg";
import { ReactComponent as PublicQuotationIcon } from "../../assets/svg/cotizaciones.svg";



const QuePasaEnEdify = ({
  getTotalUsers,
  totalUsers,
  getTotalPublicProjects,
  totalPublicProjects,
  getTotalPublicQuotations,
  getTotalPrivateQuotations,
  totalPublicQuotations,
  getTotalNewUsers,

  getTotalNewPublicProjects,
  getTotalNewPrivateProjects,
  getTotalNewPublicQuotations,
  getTotalNewPrivateQuotations,
  lastNewUser = [],
  lastPublicProject = [],
  lastPublicQuotation = [],
}) => {
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  //Obtenemos los datos para el dashboard

  useEffect(() => {
    getTotalUsers();
    getTotalPublicProjects();
    getTotalPublicQuotations();
  }, [getTotalUsers, getTotalPublicProjects, getTotalPublicQuotations]);

  //Maneja la redirección al perfil del usuario
  const handleClickProfile = () => {
    const userName = lastNewUser.type === "COMPANY" ? lastNewUser.razon_social : lastNewUser?.name + " " + lastNewUser?.last_name;
    history.push(`/comunidad-edify/${lastNewUser?.id}/${userName}`);
  }

  //Maneja la redirección a la ultima obra pública
  const handleClickOpenProject = (quotation) => {
    if (quotation) window.open(`/materiales-a-licitar-publicos/${lastPublicQuotation.id}/${lastPublicQuotation.name}`, "_blank");
    else
      window.open(`/obra-publica-a-licitar/${lastPublicProject?.id}/${lastPublicProject?.name}`, "_blank");
  }

  //Obtenemos nombre completo del usuario
  const nombreCompleto = lastNewUser?.type === "COMPANY" ? lastNewUser.razon_social : lastNewUser?.name + " " + lastNewUser?.last_name;

  //Cantidad máxima de caracteres a mostrar
  const maxCharactersToShow = 20;

  // Función para recortar el texto y agregar puntos suspensivos
  const truncateText = (text, name) => {
    if ((text !== undefined && text !== null) && text.length > maxCharactersToShow) {
      return text.slice(0, (name ? 18 : maxCharactersToShow)) + '...';
    }
    return text;
  };

  return (
    <main className={styles.QuePasaEnEdify}>
      <div className={styles.QuePasaEnEdify_container}>
        <div className={styles.QuePasaEnEdify_container_content}>
          <div className={styles.cantidadContainer}>
            <p className={styles.userCantidad}>{totalUsers?.totalUsers}</p>
            <div className={styles.QuePasaEnEdify_container_content_item}>
              Usuarios
            </div>
          </div>
          {lastNewUser.length !== 0 && (
          <div className={styles.notificationContainer}>
            <div className={styles.notificationContainer_header}>
              <p className={styles.notificationContainer_title}>nuevo</p>
              <PlusIcon height={20} width={20} />
            </div>
            <div
              className={styles.notificationContainer_profile}
              onClick={() => handleClickProfile()}
            >
              <img
                className={styles.notificationContainer_profile_image}
                src={lastNewUser?.image_profile}
                alt="user"
              />
              <div className={styles.notificationContainer_info}>
                <span className={styles.notificationContainer_userName}>{nombreCompleto === "null null" ? "Usuario sin nombre" : truncateText(nombreCompleto, true)}</span>
                <span className={styles.notificationContainer_rubro}>
                  {truncateText((lastNewUser?.rubro === "undefined" || lastNewUser?.rubro === null) ? lastNewUser?.profession : lastNewUser?.rubro)}
                </span>
              </div>
            </div>
          </div>
          )}
          {lastPublicProject?.length > 0 && (
            <>
          <div className={styles.cantidadContainer}>
            <p className={styles.obrasCantidad}>{totalPublicProjects}</p>
            <div className={styles.QuePasaEnEdify_container_content_item}>
              Obras Públicas
            </div>
          </div>
          <div className={styles.notificationContainer}>
            <div className={styles.notificationContainer_header}>
              <p className={styles.notificationContainer_title}>nueva</p>
              <PlusIcon height={20} width={20} />
            </div>
            <div className={styles.notificationContainer_publicProject} onClick={() => handleClickOpenProject()}>
              <div className={styles.notificationContainer_publicProject_icon}>
                <PublicProjectIcon height={30} width={30} />
              </div>
              <div className={styles.notificationContainer_publicProject_info}>
                <span className={styles.notificationContainer_publicProject_name}>
                  {truncateText(lastPublicProject?.name)}
                </span>
                <span className={styles.notificationContainer_publicProject_zone}>
                  {truncateText(lastPublicProject?.zone)}
                </span>
              </div>
            </div>
          </div>
          </>
          )}
          <div className={styles.cantidadContainer}>
            <p className={styles.cotizacionCantidad}>{totalPublicQuotations}</p>
            <div className={styles.QuePasaEnEdify_container_content_item}>
              Cotización de Materiales
            </div>
          </div>
          {lastPublicQuotation.length !== 0 && (
          <div className={styles.notificationContainer}>
            <div className={styles.notificationContainer_header}>
              <p className={styles.notificationContainer_title}>nueva</p>
              <PlusIcon height={20} width={20} />
            </div>
            <div className={styles.notificationContainer_publicQuotation} onClick={() => handleClickOpenProject(true)}>
              <div className={styles.notificationContainer_publicQuotation_icon}>
                <PublicQuotationIcon height={30} width={30} />
              </div>
              <div className={styles.notificationContainer_publicQuotation_info}>
                <span className={styles.notificationContainer_publicQuotation_name}>
                  {truncateText(lastPublicQuotation?.name)}
                </span>
                <span className={styles.notificationContainer_publicQuotation_zone}>
                  {truncateText(lastPublicQuotation?.zone)}
                </span>
              </div>
            </div>
          </div>
          )}
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => {
  return {
    totalUsers: state.dashboard.totalUsers,
    totalPublicProjects: state.dashboard.totalPublicProjects,
    totalPublicQuotations: state.dashboard.totalPublicQuotations,
    totalPrivateQuotations: state.dashboard.totalPrivateQuotations,
    totalNewUsers: state.dashboard.totalNewUsers,
    totalNewPublicProjects: state.dashboard.totalNewPublicProjects,
    totalNewPrivateProjects: state.dashboard.totalNewPrivateProjects,
    totalNewPublicQuotations: state.dashboard.totalNewPublicQuotations,
    totalNewPrivateQuotations: state.dashboard.totalNewPrivateQuotations,
    lastNewUser: state.dashboard.lastNewUser,
    lastPublicProject: state.dashboard.lastPublicProject,
    lastPublicQuotation: state.dashboard.lastPublicQuotation,
  };
}

export default connect(mapStateToProps, {
  getTotalUsers,
  getTotalPublicProjects,
  getTotalPublicQuotations,
  getTotalPrivateQuotations,
  getTotalNewUsers,
  getTotalNewPublicProjects,
  getTotalNewPrivateProjects,
  getTotalNewPublicQuotations,
  getTotalNewPrivateQuotations,
})(QuePasaEnEdify);
